module.exports = __webpack_public_path__ + "media/images/logo-bg-b6cb4c743a9edf48b12d29b2717b2504.svg";